import styled, { device } from "@styled";

export const CommentWrap = styled.div`
    margin-block-start: 50px;
    ${device.large} {
        margin-block-start: 70px;
    }
`;

export const SectionTItle = styled.div`
    margin-block-end: 47px;
`;
